import { APIError, PaymentMethod } from '@ads-bread/shared/bread/codecs';
import {
  FetchPaymentMethodResult,
  CreatePaymentMethodResult,
  FetchPaymentMethodsResult,
} from './types/actors';

/**
 * Helper function to extract payment method from either
 * FetchPaymentMethodResult or CreatePaymentMethodResult
 * @param params FetchPaymentMethodResult | CreatePaymentMethodResult
 * @returns PaymentMethod | undefined
 */
export const getPaymentMethodResult = (
  params: FetchPaymentMethodResult | CreatePaymentMethodResult
): PaymentMethod | undefined => {
  if ('paymentMethodRes' in params) {
    return params.paymentMethodRes.result?.paymentMethod;
  }
  return params.createPaymentMethodsRes.result?.paymentMethod;
};

/**
 * Helper function to extract API error from either
 * FetchPaymentMethodResult, CreatePaymentMethodResult or FetchPaymentMethodsResult
 * @param params FetchPaymentMethodResult | CreatePaymentMethodResult | FetchPaymentMethodsResult
 * @returns APIError | null
 */
export const getPaymentMethodError = (
  params:
    | FetchPaymentMethodResult
    | CreatePaymentMethodResult
    | FetchPaymentMethodsResult
): APIError | null => {
  if ('paymentMethodRes' in params) {
    return params.paymentMethodRes.error;
  }
  if ('createPaymentMethodsRes' in params) {
    return params.createPaymentMethodsRes.error;
  }
  return params.paymentMethodsRes?.error ?? null;
};
